import React, { Component, Fragment } from "react";
import NumberFormat from 'react-number-format';
import { getDataIsUser, saveDataUser,loadInfoUser} from '../../actions/adminPageAction';
import { getDataFeature} from '../../actions/authActions';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import Moment from 'react-moment';
import { Link } from "react-router-dom";
import iconLikeCmtShare from '../../icon/vip_like.png';
import iconSub from '../../icon/buff_sub.png';
import iconReview from '../../icon/buff_comment.png';
import iconLike2 from '../../icon/buff_like.png';
import iconCMT2 from '../../icon/vip_cmt.png';
import iconView from '../../icon/buff_view.png';
import iconSub2 from '../../icon/buff_share_profile.png';
import iconSub3 from '../../icon/buff_share.png';
import iconCoin from '../../icon/coin.png';
import iconCoins from '../../icon/coins.png';
import iconAdmin from '../../icon/admin.png';
import { Lightbox } from "react-modal-image";
import ModalImage from "react-modal-image";
import { FiSmile } from "react-icons/fi";
import { AiOutlineCamera, AiOutlineFileGif, AiOutlinePicture, AiOutlineLike } from "react-icons/ai";
import { BiComment } from "react-icons/bi";
import { BsReply } from "react-icons/bs";
import Admin1 from '../../icon/admin1.png';
import Users1 from '../../icon/users1.png';

class Quanlytaikhoan extends Component {
	state = {
		dataUser: {},
		formdata: {
			name_user: '',
			email_user: '',
			phone_user: '',
			idfacebook_user: '',
			re_pass_user: '',
			new_pass_user: '',
		},
		loadding_page: true,
		open: false,
	}
	componentDidMount(){
		// this.props.getDataFeature(9999,'');
        // this.props.getDataIsUser().then(res => {
        	// if (res.data.status !== 200) {
				// Swal.fire({ icon: 'error', title: 'Lỗi', text: res.data.msg });
			// } else {
				// this.setState({
					// dataUser: res.data.data
				// })
			// }
        // })
        // this.props.loadInfoUser().then(res =>{
        	// this.setState({
				// formdata: {
					// ...this.state.formdata,
					// name_user: res.data.username,
					// email_user: res.data.email !== null ? res.data.email : '',
					// phone_user: res.data.phone !== null ? res.data.phone : '',
					// idfacebook_user: res.data.facebook_id !== null ? res.data.facebook_id : '',
					// notes: res.data.notes !== null ? res.data.notes : '',
				// },
				// loadding_page: false,
			// });
        // });
    }

    betwen2date = (timeCheck) => {
    	if (typeof timeCheck !== 'undefined') {
	    	const oneDay = 24 * 60 * 60 * 1000;
			const firstDate = new Date(timeCheck*1000);
			const secondDate = new Date();

			const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
			return diffDays;
    	}
    }
    ChangeInfoUser = (e) => {
		this.setState({
			formdata: {
				...this.state.formdata,
				[e.target.name]: e.target.value
			}
		});
	}
	renderImage(img){
		if (img === '{iconLikeCmtShare}') {
			return iconLikeCmtShare;
		}
		if (img === '{iconSub}') {
			return iconSub;
		}
		if (img === '{iconReview}') {
			return iconReview;
		}
		if (img === '{iconLike2}') {
			return iconLike2;
		}
		if (img === '{iconCMT2}') {
			return iconCMT2;
		}
		if (img === '{iconView}') {
			return iconView;
		}
		if (img === '{iconSub2}') {
			return iconSub2;
		}
		if (img === '{iconSub3}') {
			return iconSub3;
		}
		return img;
	}
	closeLightbox = () => {
		this.state.open = false;
	}
	openLightbox = () => {
		this.state.open = true;
	}
  	render() {
  		const {dataUser} = this.state;
  		const { listDataFeature} = this.props.adminpage;
  		const { list_noti, user } = this.props.auth;

  		var that = this;
  		// var facebooksevice = (
  			// <Fragment>
  				// {
  					// listDataFeature.map(function(value,index){
  						// var classcss = 'sevice_onl';
  						// if (value.active === 'Bảo trì' || value.active === 'Dừng hoạt động') {
  							// classcss = 'sevice_offl';
  						// }
  						// if (value.type_category === 'Facebook') {
  							// return (<Link to={value.link} className="col-md-3 px-1 mt-3 " key={index}>
  									// <div className="item-service">
  										// <div className="row p-3">
	  										// <div className=" col-md-4 img-serv-site">
	  											// <img src={that.renderImage(value.icon)} alt="group-icon" width="50" className="group-icon" />
	  										// </div>
	  										// <div className=" col-md-8 text-serv-site">
									         	// <h6 className="font-14">{value.name}</h6>
									      		// <span className={classcss}>{value.active}</span>
	  										// </div>
  										// </div>
  									// </div>
									// </Link>);
  						// } else {
  							// return ('');
  						// }
  					// })
  				// }
  			// </Fragment>
  		// );
  		// var instagramsevice = (
  			// <Fragment>
  				// {
  					// listDataFeature.map(function(value,index){
  						// var classcss = 'sevice_onl';
  						// if (value.active === 'Bảo trì' || value.active === 'Dừng hoạt động') {
  							// classcss = 'sevice_offl';
  						// }

  						// if (value.type_category === 'Instagram') {
  							// return (<Link to={value.link} className="col-md-3 px-1 mt-3 " key={index}>
  									// <div className="item-service">
  										// <div className="row p-3">
	  										// <div className=" col-md-4 img-serv-site">
	  											// <img src={that.renderImage(value.icon)} alt="group-icon" width="50" className="group-icon" />
	  										// </div>
	  										// <div className=" col-md-8 text-serv-site">
									         	// <h6 className="font-14">{value.name}</h6>
									      		// <span className={classcss}>{value.active}</span>
	  										// </div>
  										// </div>
  									// </div>
									// </Link>);
  						// } else {
  							// return ('');
  						// }
  					// })
  				// }
  			// </Fragment>
  		// );
  		// var youtubesevice = (
  			// <Fragment>
  				// {
  					// listDataFeature.map(function(value,index){
  						// var classcss = 'sevice_onl';
  						// if (value.active === 'Bảo trì' || value.active === 'Dừng hoạt động') {
  							// classcss = 'sevice_offl';
  						// }

  						// if (value.type_category === 'Youtube') {
  							// return (<Link to={value.link} className="col-md-3 px-1 mt-3 " key={index}>
  									// <div className="item-service">
  										// <div className="row p-3">
	  										// <div className=" col-md-4 img-serv-site">
	  											// <img src={that.renderImage(value.icon)} alt="group-icon" width="50" className="group-icon" />
	  										// </div>
	  										// <div className=" col-md-8 text-serv-site">
									         	// <h6 className="font-14">{value.name}</h6>
									      		// <span className={classcss}>{value.active}</span>
	  										// </div>
  										// </div>
  									// </div>
									// </Link>);
  						// } else {
  							// return ('');
  						// }
  					// })
  				// }
  			// </Fragment>
  		// );
  		// var tiktoksevice = (
  			// <Fragment>
  				// {
  					// listDataFeature.map(function(value,index){
  						// var classcss = 'sevice_onl';
  						// if (value.active === 'Bảo trì' || value.active === 'Dừng hoạt động') {
  							// classcss = 'sevice_offl';
  						// }
  						// if (value.type_category === 'Tiktok') {
  							// return (<Link to={value.link} className="col-md-3 px-1 mt-3 " key={index}>
  									// <div className="item-service">
  										// <div className="row p-3">
	  										// <div className=" col-md-4 img-serv-site">
	  											// <img src={that.renderImage(value.icon)} alt="group-icon" width="50" className="group-icon" />
	  										// </div>
	  										// <div className=" col-md-8 text-serv-site">
									         	// <h6 className="font-14">{value.name}</h6>
									      		// <span className={classcss}>{value.active}</span>
	  										// </div>
  										// </div>
  									// </div>
									// </Link>);
  						// } else {
  							// return ('');
  						// }
  					// })
  				// }
  			// </Fragment>
  		// );
  		// var shoppesevice = (
  			// <Fragment>
  				// {
  					// listDataFeature.map(function(value,index){
  						// var classcss = 'sevice_onl';
  						// if (value.active === 'Bảo trì' || value.active === 'Dừng hoạt động') {
  							// classcss = 'sevice_offl';
  						// }
  						// if (value.type_category === 'Shoppe') {
  							// return (<Link to={value.link} className="col-md-3 px-1 mt-3 " key={index}>
  									// <div className="item-service">
  										// <div className="row p-3">
	  										// <div className=" col-md-4 img-serv-site">
	  											// <img src={that.renderImage(value.icon)} alt="group-icon" width="50" className="group-icon" />
	  										// </div>
	  										// <div className=" col-md-8 text-serv-site">
									         	// <h6 className="font-14">{value.name}</h6>
									      		// <span className={classcss}>{value.active}</span>
	  										// </div>
  										// </div>
  									// </div>
									// </Link>);
  						// } else {
  							// return ('');
  						// }
  					// })
  				// }
  			// </Fragment>
  		// );
		if (list_noti !== "") {
			var cardthongbao = (
				<Fragment>
					{
						list_noti.map(function(v, i) {
							if (i <= 10) {
								return (
									<div className="col-md-12 px-0" key={i}>
										<div className="block block-bordered" style={{"borderRadius": "10px"}}>
											<div className="block-header" style={{"borderRadius": "10px 10px 0px 0px"}}>
												<h3 className="block-title">
													<div className="row align-items-center">
														<div className="col-auto pr-0">
															<a href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" className="profile-pic">
																{/* <img src="https://graph.facebook.com/4/picture?width=100&amp;amp;height=100" width="160" alt="user" className="img-avatars rounded-circle border"/> */}
																<img src={iconAdmin} width="160" alt="user" className="img-avatars rounded-circle border"/>
															</a>
														</div>
														<div className="col text-left">
															<div className="row align-items-center mt-1">
																<div className="col">
																	<h6 className="bold font-22 mb-0">
																		<span className="font-bold" style={{"color": "#1877F2"}}>Quản Trị Viên </span><i className="fa fa-check-circle" style={{"color": "#1877F2"}}></i>
																	</h6>
																</div>
															</div>
															<div className="row align-items-center mt-1">
																<div className="col">
																	<h6 className="bold font-22 mb-0 text-secondary">
																		<span style={{"overflow": "hidden", "verticalAlign": "middle"}}><Moment format="DD">{v.create_at * 1000}</Moment> tháng <Moment format="MM ">{v.create_at * 1000}</Moment></span>
																		<span style={{"overflow": "hidden", "verticalAlign": "middle"}}>lúc <Moment format="HH:mm ">{v.create_at * 1000}</Moment></span>
																		<svg className="svg-inline--fa fa-globe-americas fa-w-16" style={{"width": "1em"}} aria-hidden="true" focusable="false" data-prefix="fas" data-icon="globe-americas" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512" data-fa-i2svg=""><path fill="currentColor" d="M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"></path></svg>
																	</h6>
																</div>
															</div>
														</div>
													</div>
												</h3>
											</div>
											<div className="block-content" style={{whiteSpace: "pre-wrap"}}>
												{/* <p style={{"fontSize": "30px", "color" : "red"}}>{ Buffer.from(v.title, 'base64').toString('utf8') }</p> */}
												<p style={{"fontSize": "20px"}}>{ Buffer.from(v.content, 'base64').toString('utf8') }</p>
												{
													v.image != '' && v.image != null ?
														<Fragment>
															<ModalImage
																className="modalimage-cus"
																small={ v.image }
																large={ v.image }
																alt={ v.image }
															/>
														</Fragment>
													: ''
												}
												{
													v.video != '' && v.video != null ?
														<iframe height="420" style={{"width":"100%", "margin":"0px auto 10px auto"}} src={ "https://www.youtube.com/embed/"+v.video } frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
													: ''
												}
											</div>
											<div className="" style={{whiteSpace: "pre-wrap", "borderTop": "1px solid rgb(224 224 224)", "padding": "15px 20px"}}>
												<img className="j1lvzwm4" height="24" src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 16 16'%3e%3cdefs%3e%3clinearGradient id='a' x1='50%25' x2='50%25' y1='0%25' y2='100%25'%3e%3cstop offset='0%25' stop-color='%2318AFFF'/%3e%3cstop offset='100%25' stop-color='%230062DF'/%3e%3c/linearGradient%3e%3cfilter id='c' width='118.8%25' height='118.8%25' x='-9.4%25' y='-9.4%25' filterUnits='objectBoundingBox'%3e%3cfeGaussianBlur in='SourceAlpha' result='shadowBlurInner1' stdDeviation='1'/%3e%3cfeOffset dy='-1' in='shadowBlurInner1' result='shadowOffsetInner1'/%3e%3cfeComposite in='shadowOffsetInner1' in2='SourceAlpha' k2='-1' k3='1' operator='arithmetic' result='shadowInnerInner1'/%3e%3cfeColorMatrix in='shadowInnerInner1' values='0 0 0 0 0 0 0 0 0 0.299356041 0 0 0 0 0.681187726 0 0 0 0.3495684 0'/%3e%3c/filter%3e%3cpath id='b' d='M8 0a8 8 0 00-8 8 8 8 0 1016 0 8 8 0 00-8-8z'/%3e%3c/defs%3e%3cg fill='none'%3e%3cuse fill='url(%23a)' xlink:href='%23b'/%3e%3cuse fill='black' filter='url(%23c)' xlink:href='%23b'/%3e%3cpath fill='white' d='M12.162 7.338c.176.123.338.245.338.674 0 .43-.229.604-.474.725a.73.73 0 01.089.546c-.077.344-.392.611-.672.69.121.194.159.385.015.62-.185.295-.346.407-1.058.407H7.5c-.988 0-1.5-.546-1.5-1V7.665c0-1.23 1.467-2.275 1.467-3.13L7.361 3.47c-.005-.065.008-.224.058-.27.08-.079.301-.2.635-.2.218 0 .363.041.534.123.581.277.732.978.732 1.542 0 .271-.414 1.083-.47 1.364 0 0 .867-.192 1.879-.199 1.061-.006 1.749.19 1.749.842 0 .261-.219.523-.316.666zM3.6 7h.8a.6.6 0 01.6.6v3.8a.6.6 0 01-.6.6h-.8a.6.6 0 01-.6-.6V7.6a.6.6 0 01.6-.6z'/%3e%3c/g%3e%3c/svg%3e" width="24" />
												<img className="j1lvzwm4" height="24" src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 16 16'%3e%3cdefs%3e%3clinearGradient id='a' x1='50%25' x2='50%25' y1='10.25%25' y2='100%25'%3e%3cstop offset='0%25' stop-color='%23FEEA70'/%3e%3cstop offset='100%25' stop-color='%23F69B30'/%3e%3c/linearGradient%3e%3clinearGradient id='d' x1='50%25' x2='50%25' y1='0%25' y2='100%25'%3e%3cstop offset='0%25' stop-color='%23472315'/%3e%3cstop offset='100%25' stop-color='%238B3A0E'/%3e%3c/linearGradient%3e%3clinearGradient id='e' x1='50%25' x2='50%25' y1='0%25' y2='81.902%25'%3e%3cstop offset='0%25' stop-color='%23FC607C'/%3e%3cstop offset='100%25' stop-color='%23D91F3A'/%3e%3c/linearGradient%3e%3cfilter id='c' width='118.8%25' height='118.8%25' x='-9.4%25' y='-9.4%25' filterUnits='objectBoundingBox'%3e%3cfeGaussianBlur in='SourceAlpha' result='shadowBlurInner1' stdDeviation='1'/%3e%3cfeOffset dy='-1' in='shadowBlurInner1' result='shadowOffsetInner1'/%3e%3cfeComposite in='shadowOffsetInner1' in2='SourceAlpha' k2='-1' k3='1' operator='arithmetic' result='shadowInnerInner1'/%3e%3cfeColorMatrix in='shadowInnerInner1' values='0 0 0 0 0.921365489 0 0 0 0 0.460682745 0 0 0 0 0 0 0 0 0.35 0'/%3e%3c/filter%3e%3cpath id='b' d='M16 8A8 8 0 110 8a8 8 0 0116 0'/%3e%3c/defs%3e%3cg fill='none'%3e%3cuse fill='url(%23a)' xlink:href='%23b'/%3e%3cuse fill='black' filter='url(%23c)' xlink:href='%23b'/%3e%3cpath fill='url(%23d)' d='M3 8.008C3 10.023 4.006 14 8 14c3.993 0 5-3.977 5-5.992C13 7.849 11.39 7 8 7c-3.39 0-5 .849-5 1.008'/%3e%3cpath fill='url(%23e)' d='M4.541 12.5c.804.995 1.907 1.5 3.469 1.5 1.563 0 2.655-.505 3.459-1.5-.551-.588-1.599-1.5-3.459-1.5s-2.917.912-3.469 1.5'/%3e%3cpath fill='%232A3755' d='M6.213 4.144c.263.188.502.455.41.788-.071.254-.194.369-.422.371-.78.011-1.708.255-2.506.612-.065.029-.197.088-.332.085-.124-.003-.251-.058-.327-.237-.067-.157-.073-.388.276-.598.545-.33 1.257-.48 1.909-.604a7.077 7.077 0 00-1.315-.768c-.427-.194-.38-.457-.323-.6.127-.317.609-.196 1.078.026a9 9 0 011.552.925zm3.577 0a8.953 8.953 0 011.55-.925c.47-.222.95-.343 1.078-.026.057.143.104.406-.323.6a7.029 7.029 0 00-1.313.768c.65.123 1.363.274 1.907.604.349.21.342.44.276.598-.077.18-.203.234-.327.237-.135.003-.267-.056-.332-.085-.797-.357-1.725-.6-2.504-.612-.228-.002-.351-.117-.422-.37-.091-.333.147-.6.41-.788z'/%3e%3c/g%3e%3c/svg%3e" width="24"/>
												<img className="j1lvzwm4" height="24" src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 16 16'%3e%3cdefs%3e%3clinearGradient id='a' x1='50%25' x2='50%25' y1='0%25' y2='100%25'%3e%3cstop offset='0%25' stop-color='%23FF6680'/%3e%3cstop offset='100%25' stop-color='%23E61739'/%3e%3c/linearGradient%3e%3cfilter id='c' width='118.8%25' height='118.8%25' x='-9.4%25' y='-9.4%25' filterUnits='objectBoundingBox'%3e%3cfeGaussianBlur in='SourceAlpha' result='shadowBlurInner1' stdDeviation='1'/%3e%3cfeOffset dy='-1' in='shadowBlurInner1' result='shadowOffsetInner1'/%3e%3cfeComposite in='shadowOffsetInner1' in2='SourceAlpha' k2='-1' k3='1' operator='arithmetic' result='shadowInnerInner1'/%3e%3cfeColorMatrix in='shadowInnerInner1' values='0 0 0 0 0.710144928 0 0 0 0 0 0 0 0 0 0.117780134 0 0 0 0.349786932 0'/%3e%3c/filter%3e%3cpath id='b' d='M8 0a8 8 0 100 16A8 8 0 008 0z'/%3e%3c/defs%3e%3cg fill='none'%3e%3cuse fill='url(%23a)' xlink:href='%23b'/%3e%3cuse fill='black' filter='url(%23c)' xlink:href='%23b'/%3e%3cpath fill='white' d='M10.473 4C8.275 4 8 5.824 8 5.824S7.726 4 5.528 4c-2.114 0-2.73 2.222-2.472 3.41C3.736 10.55 8 12.75 8 12.75s4.265-2.2 4.945-5.34c.257-1.188-.36-3.41-2.472-3.41'/%3e%3c/g%3e%3c/svg%3e" width="24"/>
												<span className="text-secondary" style={{"display": "inline-block", "width": "40%"}}> {Math.floor(1 + Math.random() * (500 - 1))}K</span>
												{/* <span className="text-secondary" style={{"display": "inline-block", "width": "33%"}}> {Math.floor(1 + Math.random() * (5000 - 1))} bình luận</span>
												<span className="text-secondary" style={{"display": "inline-block", "float": "right"}}> {Math.floor(1 + Math.random() * (2000 - 1))} chia sẻ</span> */}
												<br/>
												<div style={{"position": "relative", "borderTop": "1px solid rgb(224 224 224)", "borderBottom": "1px solid rgb(224 224 224)", "marginTop": "10px"}}>
													<div className="font-bold text-secondary" style={{"display": "inline-block", "width": "33%", "textAlign": "center", "padding": "10px"}}>
														<AiOutlineLike style={{"fontSize": "24px", "verticalAlign": "-4px"}} /> Thích
													</div>
													<div className="font-bold text-secondary" style={{"display": "inline-block", "width": "34%", "textAlign": "center", "padding": "10px"}}>
														<BiComment style={{"fontSize": "24px"}} /> Bình luận
													</div>
													<div className="font-bold text-secondary" style={{"display": "inline-block", "width": "33%", "textAlign": "center", "padding": "10px"}}>
														<BsReply style={{"fontSize": "24px", "verticalAlign": "-4px"}} /> Chia sẻ
													</div>
												</div>
												<div style={{"position": "relative"}}>
													<img src={ user.type == 1 ? Admin1 : Users1 } width="160" alt="user" className="img-avatars rounded-circle border mr-2" style={{"display": "inline-block", "marginTop": "10px"}} />
													<input className="inputwritecomment" style={{"display": "inline-block", "paddingLeft": "10px", "borderRadius": "18px", "backgroundColor": "#e6ebf4", "border": "1px solid #e6ebf4", "width": "95%", "height": "40px", "marginTop": "15px", "position": "absolute"}} placeholder="Viết bình luận..." disabled="disabled"/>
													<FiSmile style={{"position": "absolute", "right": "14px", "top": "20px", "fontSize": "28px"}}/>
													{/* <AiOutlineCamera style={{"position": "absolute", "right": "115px", "top": "14px", "fontSize": "30px"}}/>
													<AiOutlineFileGif style={{"position": "absolute", "right": "75px", "top": "14px", "fontSize": "30px"}}/>
													<AiOutlinePicture style={{"position": "absolute", "right": "35px", "top": "14px", "fontSize": "30px"}}/> */}
													<span className="" style={{"position": "absolute", "top": "60px"}}>Nhấn Enter để đăng.</span>
												</div>
											</div>
										</div>
									</div>
								);
							} else {
								return ('');
							}
						})
					}
				</Fragment>
			);
		} else {
			var cardthongbao = '';
		}
    	return (
    		<Fragment>
	    		<div className="row" data-toggle="appear" >
			    	<div className="col-md-12 w-100">
			    		<div style={{"background": "transparent"}} className="block">
			    			<div className="block-content tab-content overflow-hidden">
			    				<div className="row">
									{/* <div className="col-md-3 px-1 mt-3 d-flex">
								        <a className="block block-rounded block-link-shadow w-100" href="/#" style={{"boxShadow":"rgba(2, 2, 2, 0.25) 0px 0px 1.25rem"}}>
								            <div className="block-content block-content-full">
								                <div className="py-4 text-center">
								                    <div className="mb-3">
								                        <i className="far fa-calendar fa-3x text-xinspire"></i>
								                    </div>
								                    <div className="font-size-h4 font-w600">NGÀY SỬ DỤNG</div>
								                    <div className="text-muted">{this.betwen2date(user.create_at)} ngày</div>
								                </div>
								            </div>
								        </a>
								    </div>
								    <div className="col-md-3 px-1 mt-3 d-flex">
								        <a className="block block-rounded block-link-shadow w-100" href="/#" style={{"boxShadow":"rgba(2, 2, 2, 0.25) 0px 0px 1.25rem"}}>
								            <div className="block-content block-content-full">
								                <div className="py-4 text-center">
								                    <div className="mb-3">
								                        <i className="fa fa-user fa-3x text-xsmooth"></i>
								                    </div>
								                    <div className="font-size-h4 font-w600">LOẠI TÀI KHOẢN</div>
								                    <div className="text-muted">{user.notes}</div>
								                </div>
								            </div>
										</a>
									</div> */}
								    <div className="col-md-6 px-1 mt-3 d-flex">
								        <a className="block block-rounded block-link-shadow w-100" href="/#" style={{"boxShadow":"rgba(2, 2, 2, 0.25) 0px 0px 1.25rem", "height": "fit-content"}}>
								            <div className="block-content block-content-full" style={{"padding": "0px"}}>
								                <div className="py-3 text-center">
								                    <div className="mb-3">
								                        <img src={iconCoin} alt="group-icon" width="50" className="group-icon" />
								                    </div>
								                    <div className="font-size-h4 font-w600">SỐ DƯ</div>
								                    <div className="text-muted"><NumberFormat value={ user.money } displayType={'text'} thousandSeparator={true} suffix={' VND'} /></div>
								                </div>
								            </div>
								        </a>
								    </div>
								    <div className="col-md-6 px-1 mt-3 d-flex">
								        <a className="block block-rounded block-link-shadow w-100" href="/#" style={{"boxShadow":"rgba(2, 2, 2, 0.25) 0px 0px 1.25rem", "height": "fit-content"}}>
								            <div className="block-content block-content-full" style={{"padding": "0px"}}>
								                <div className="py-3 text-center">
								                    <div className="mb-3">
								                       <img src={iconCoins} alt="group-icon" width="50" className="group-icon" />
								                    </div>
								                    <div className="font-size-h4 font-w600">TIỀN ĐÃ NẠP</div>
								                    <div className="text-muted"><NumberFormat value={ user.tien_nap } displayType={'text'} thousandSeparator={true} suffix={' VND'} /></div>
								                </div>
								            </div>
								        </a>
								    </div>
			    				</div>
			    				<div className="row">
									{/* <div className="w-100" style={{"marginTop":"25px"}}>
							    		<h2 style={{"textAlign":"center"}}>DỊCH VỤ FACEBOOK</h2>
							    		<div className="row item-service-facebook">
							    			{facebooksevice}
							    		</div>
							    	</div>

									<div className="w-100" style={{"marginTop":"25px"}}>
							    		<h2 style={{"textAlign":"center"}}>DỊCH VỤ INSTAGRAM</h2>
							    		<div className="row item-service-facebook">
							    			{instagramsevice}
							    		</div>
							    	</div>
							    	<div className="w-100" style={{"marginTop":"25px"}}>
							    		<h2 style={{"textAlign":"center"}}>DỊCH VỤ YOUTUBE</h2>
							    		<div className="row item-service-facebook">
							    			{youtubesevice}
							    		</div>
							    	</div>
							    	<div className="w-100" style={{"marginTop":"25px"}}>
							    		<h2 style={{"textAlign":"center"}}>DỊCH VỤ TIKTOK</h2>
							    		<div className="row item-service-facebook">
							    			{tiktoksevice}
							    		</div>
							    	</div>
							    	<div className="w-100" style={{"marginTop":"25px"}}>
							    		<h2 style={{"textAlign":"center"}}>DỊCH VỤ SHOPPE</h2>
							    		<div className="row item-service-facebook">
											{shoppesevice}
							    		</div>
									</div> */}
									{cardthongbao}
			    				</div>
			    			</div>
			    		</div>
			    		
			    	</div>
				</div>
    		</Fragment>
		);
  	}
}

const mapStateToProps = state => ({
	auth: state.auth,
	adminpage: state.adminpage
});

export default connect(mapStateToProps, { getDataIsUser, saveDataUser,loadInfoUser, getDataFeature}) (Quanlytaikhoan);
